"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/legacy_portal_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse = exports.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest = exports.LegacyPortalEventServiceGetWatchlistEventGoodsResponse = exports.LegacyPortalEventServiceGetWatchlistEventGoodsRequest = exports.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse = exports.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest = exports.LegacyPortalEventServiceAddEventGoodsToWatchlistResponse = exports.LegacyPortalEventServiceAddEventGoodsToWatchlistRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const legacy_portal_common_pb_1 = require("./legacy_portal_common_pb");
/**
 * ウォッチリストに追加
 *
 * @generated from message spwn.event.v1.LegacyPortalEventServiceAddEventGoodsToWatchlistRequest
 */
class LegacyPortalEventServiceAddEventGoodsToWatchlistRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントグッズのFirestore ID
         *
         * @generated from field: string event_goods_firestore_id = 1;
         */
        this.eventGoodsFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalEventServiceAddEventGoodsToWatchlistRequest, a, b);
    }
}
exports.LegacyPortalEventServiceAddEventGoodsToWatchlistRequest = LegacyPortalEventServiceAddEventGoodsToWatchlistRequest;
LegacyPortalEventServiceAddEventGoodsToWatchlistRequest.runtime = protobuf_1.proto3;
LegacyPortalEventServiceAddEventGoodsToWatchlistRequest.typeName = "spwn.event.v1.LegacyPortalEventServiceAddEventGoodsToWatchlistRequest";
LegacyPortalEventServiceAddEventGoodsToWatchlistRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_goods_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.LegacyPortalEventServiceAddEventGoodsToWatchlistResponse
 */
class LegacyPortalEventServiceAddEventGoodsToWatchlistResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceAddEventGoodsToWatchlistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalEventServiceAddEventGoodsToWatchlistResponse, a, b);
    }
}
exports.LegacyPortalEventServiceAddEventGoodsToWatchlistResponse = LegacyPortalEventServiceAddEventGoodsToWatchlistResponse;
LegacyPortalEventServiceAddEventGoodsToWatchlistResponse.runtime = protobuf_1.proto3;
LegacyPortalEventServiceAddEventGoodsToWatchlistResponse.typeName = "spwn.event.v1.LegacyPortalEventServiceAddEventGoodsToWatchlistResponse";
LegacyPortalEventServiceAddEventGoodsToWatchlistResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * ウォッチリストから削除
 *
 * @generated from message spwn.event.v1.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest
 */
class LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントグッズのFirestore ID
         *
         * @generated from field: string event_goods_firestore_id = 1;
         */
        this.eventGoodsFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest, a, b);
    }
}
exports.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest = LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest;
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest.runtime = protobuf_1.proto3;
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest.typeName = "spwn.event.v1.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest";
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_goods_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse
 */
class LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse, a, b);
    }
}
exports.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse = LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse;
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse.runtime = protobuf_1.proto3;
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse.typeName = "spwn.event.v1.LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse";
LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * ユーザのウォッチリスト取得
 *
 * @generated from message spwn.event.v1.LegacyPortalEventServiceGetWatchlistEventGoodsRequest
 */
class LegacyPortalEventServiceGetWatchlistEventGoodsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalEventServiceGetWatchlistEventGoodsRequest, a, b);
    }
}
exports.LegacyPortalEventServiceGetWatchlistEventGoodsRequest = LegacyPortalEventServiceGetWatchlistEventGoodsRequest;
LegacyPortalEventServiceGetWatchlistEventGoodsRequest.runtime = protobuf_1.proto3;
LegacyPortalEventServiceGetWatchlistEventGoodsRequest.typeName = "spwn.event.v1.LegacyPortalEventServiceGetWatchlistEventGoodsRequest";
LegacyPortalEventServiceGetWatchlistEventGoodsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.event.v1.LegacyPortalEventServiceGetWatchlistEventGoodsResponse
 */
class LegacyPortalEventServiceGetWatchlistEventGoodsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ウォッチリストに登録されているイベントグッズ一覧
         *
         * @generated from field: repeated spwn.event.v1.LegacyPortalEventGoods goods = 1;
         */
        this.goods = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceGetWatchlistEventGoodsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalEventServiceGetWatchlistEventGoodsResponse, a, b);
    }
}
exports.LegacyPortalEventServiceGetWatchlistEventGoodsResponse = LegacyPortalEventServiceGetWatchlistEventGoodsResponse;
LegacyPortalEventServiceGetWatchlistEventGoodsResponse.runtime = protobuf_1.proto3;
LegacyPortalEventServiceGetWatchlistEventGoodsResponse.typeName = "spwn.event.v1.LegacyPortalEventServiceGetWatchlistEventGoodsResponse";
LegacyPortalEventServiceGetWatchlistEventGoodsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalEventGoods, repeated: true },
]);
/**
 * idを指定してイベントグッズを取得
 *
 * @generated from message spwn.event.v1.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest
 */
class LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントグッズのFirestore IDリスト
         *
         * @generated from field: repeated string event_goods_firestore_ids = 1;
         */
        this.eventGoodsFirestoreIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest, a, b);
    }
}
exports.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest = LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest;
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest.runtime = protobuf_1.proto3;
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest.typeName = "spwn.event.v1.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest";
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_goods_firestore_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse
 */
class LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 指定されたイベントグッズ一覧
         *
         * @generated from field: repeated spwn.event.v1.LegacyPortalEventGoods goods = 1;
         */
        this.goods = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse, a, b);
    }
}
exports.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse = LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse;
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse.runtime = protobuf_1.proto3;
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse.typeName = "spwn.event.v1.LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse";
LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalEventGoods, repeated: true },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map